import React, { Component, Suspense } from "react"
import { Redirect, BrowserRouter, Route, Switch } from "react-router-dom"
import uuid from "uuid"
//Package CSS
import "bootstrap/dist/css/bootstrap.min.css"
import "bootstrap/dist/js/bootstrap.min.js"
import "animate.css/animate.min.css"
//Template CSS Style
import "../src/style.min.css"
import "./assets/css/responsive.min.css"
import "./assets/css/color/color-red.min.css"
import "./assets/icofont/icofont.min.css"
import { SideButton } from "components/CustomElements/SideButton"

const Honoris = React.lazy(() => import("./pages/prepa/Honoris"))
const Contact = React.lazy(() => import("./pages/Contact"))
const Footer = React.lazy(() => import("./components/layout/Footer"))
const ScrollUpBtn = React.lazy(() => import("./components/layout/ScrollUp"))
const Home = React.lazy(() => import("./pages/Home"))
const SingleBlog = React.lazy(() => import("./pages/SingleBlog"))

const Search = React.lazy(() => import("./pages/Search"))

//Prepa
const MotDirection = React.lazy(() => import("./pages/prepa/MotDirection"))
const FuturTaupin = React.lazy(() => import("./pages/prepa/FuturTaupin"))
const Resultats = React.lazy(() => import("./pages/prepa/Resultats"))

//Affectation
const Acces = React.lazy(() => import("./pages/affectation/CondtionAcces"))
const PreInscription = React.lazy(() => import("./pages/affectation/PreInscription"))
const PouquoiPrep = React.lazy(() => import("./pages/affectation/PourquoiPrepa"))

//Formation Prepa
const Organisation = React.lazy(() => import("./pages/FormationPrepa/Organisation"))
const Programme = React.lazy(() => import("./pages/FormationPrepa/ProgrammeEvaluation"))

//Vie Etudiant Prepa
const ActuPage = React.lazy(() => import("./pages/VieEtudiantPrepa/ActuPage"))
const EventsPage = React.lazy(() => import("./pages/VieEtudiantPrepa/EventsPage"))
const Info = React.lazy(() => import("./pages/VieEtudiantPrepa/InformationPratique"))

//admission
const Admission = React.lazy(() => import("./pages/admission/Admission"))

export default class App extends Component {
  render() {
    return (
      <BrowserRouter basename="/">
        <div className="App">
          <section className="route-section">
            <Suspense
              fallback={
                <>
                  <svg className="spinner" viewBox="0 0 50 50">
                    <circle className="path" cx="25" cy="25" r="20" fill="none" strokeWidth="5"></circle>
                  </svg>
                  <style
                    dangerouslySetInnerHTML={{
                      __html: [
                        "   html,body {",
                        "  height: 100%;",
                        "   background-image: linear-gradient(-105deg, #cd2122, #212529) !important;",
                        "}"
                      ].join("\n"),
                    }}></style>
                </>
              }>
              <Switch>
                {/* <Route path="/recherche/:keyword" render={props => <Search key={uuid()} {...props} />} /> */}
                {/* <Route path="/actualite/:slug" render={props => <SingleBlog key={uuid()} {...props} />} /> */}
                <Route path="/contact" render={props => <Contact {...props} />} />
                {/* Esprit Prepa */}
                <Route path="/esprit/honoris-united-universities" render={props => <Honoris {...props} />} />
                <Route path="/esprit/Mot-direction" render={props => <MotDirection {...props} />} />
                <Route path="/esprit/Futur-taupin" render={props => <FuturTaupin {...props} />} />
                <Route path="/esprit/Resultat-Concours" render={props => <Resultats {...props} />} />

                {/* Admission Prepa */}
                <Route path="/admission/Condition-Acces" render={props => <Acces {...props} />} />
                <Route path="/admission/Pré-Inscription" render={props => <PreInscription {...props} />} />
                <Route path="/admission/Pourquoi-Prepa" render={props => <PouquoiPrep {...props} />} />

                {/* Formation Prepa */}
                <Route path="/formation-Prepa/Organisation-Pedagogique" render={props => <Organisation {...props} />} />
                <Route path="/formation-Prepa/Programme-Evaluation" render={props => <Programme {...props} />} />

                {/* Vie Etudiant Prepa */}
                {/* <Route path="/vie-etudiante/evenements" render={props => <EventsPage {...props} />} />
                <Route path="/vie-etudiante/actualites" render={props => <ActuPage {...props} />} /> */}
                <Route path="/Vie-Etudiant/Programme-Evaluation" render={props => <Info {...props} />} />
                <Route path="/admission" render={props => <Admission {...props} />} />

                <Route path="/" exact render={() => <Home />} />
                <Redirect to="/" />
              </Switch>
              <Footer />
              <ScrollUpBtn />
              <SideButton />
            </Suspense>
          </section>
          {/* </CSSTransition> */}
        </div>
      </BrowserRouter>
    )
  }
}
